<template>
    <div id="contenedor-principal-clinicas">
        <CCargandoInformacion v-if="cargandoInformacion" :mostrarError="ocurrioError"></CCargandoInformacion>
        <div v-if="!cargandoInformacion">
            <div v-if="this.campoRequeridoEsValido(datosArea)" id="titulo-area">
                <h1>{{ this.campoRequeridoEsValido(datosArea.titulo) ? datosArea.titulo : 'Comunicados' }}</h1>
                <h3>{{ datosArea.subtitulo }}</h3>
                <div class="hr-titulo"></div>
            </div>
            <CSeccion v-for="(seccion) in secciones" :key="'seccion-' + seccion.SeccionId" 
                class="espacio-entre-secciones"
                :informacion="{ idElemento: seccion.SeccionId, nombre: seccion.Nombre }"
                :formatosDeSeccion="[{ tipoDeFormato: seccion.FormatoId, contenidos: seccion.Contenidos }]"
                :opciones="{ tiposDocumentoArea: tiposDocumentosArea, carrusel: CONFIGURACION_CARRUSEL }"></CSeccion>
        </div>
    </div>
</template>
<script>
import router from '@/router/index'
import CSeccion from "@/components/Intranet/Comun/CSeccion.vue";
import api from '@/../static/js/api'
import axios from 'axios'
import comun from "@/../static/js/comun"
import CCargandoInformacion from "@/components/Intranet/Comun/CCargandoInformacion";

export default {
    components: {
        CSeccion: CSeccion,
        CCargandoInformacion: CCargandoInformacion
    },
    beforeRouteEnter (to, from, next) {
        const VISTA_RAIZ = 'Inicio';
        next(async (instanciaVue) => {
            instanciaVue.cargandoInformacion = true;
            const PAGINA_HABILITADA = await Promise.resolve(instanciaVue.usuarioTieneLaPaginaHabilitada({ ruta: to.path }));
            if(!PAGINA_HABILITADA) {
                router.push({ name: VISTA_RAIZ});
                instanciaVue.cargandoInformacion = false;
                comun.mensajeDeAlerta('No tienes acceso a la pagina solicitada', null, null);
            }
        });
    },
    data() {
        return {
            secciones: [],
            datosArea: {  titulo: 'Comunicados Presidencia', subtitulo: '' },
            tiposDocumentosArea: [],
            CONFIGURACION_CARRUSEL: {
                opciones: {
                        conFondo: false,
                        conTituloCarrusel: { mostrar: true, texto: 'Comunicados', estilosCss: 'color: #676666; font-weight: bold;' },
                        conTitulo: { mostrar: false, identificador: 'Titulo' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                        conImagen: { mostrar: true, identificador: 'RutaDeAcceso' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                        conDescripcion: { mostrar: false, identificador: 'Descripcion' }, // remplazar por propiedades reales del objeto de contenido de la entidad
                        configuraciones: { 
                            autoPlay: true,
                            dimensiones: { 
                                0: { items: true, nav: false }, 
                                600:{ items: true, nav: false },
                                800: { items: true, nav: false },
                                1200: { items: true, nav: false }
                            },
                            estilosCss: 'height: 30em; border-radius: 10px 10px 10px 10px;'
                        } 
                }
            },
            TIPOS_CONVERSION_CONTENIDOS: {
                /* NOTA: CREAR FUNCION PARA OBTENER LOS ENCABEZADOS Y AGREGAR VALIDACION EN FOR DE CONVERSION DE CONTENIDOS */
                // AVISOS
                32: ({ contenido }) => {
                    const { ContenidoDeIntreanetId, TextoDelContenido } = contenido;
                    const { Ruta } = contenido.ArchivosDeContenidoIntranet[0];
                    let contenidoObj = {};
                    contenidoObj.id = ContenidoDeIntreanetId;
                    contenidoObj.Titulo = TextoDelContenido;
                    contenidoObj.RutaDeAcceso = Ruta;
                    contenidoObj.Descripcion = TextoDelContenido;
                    return contenidoObj;
                },
            },
            cargandoInformacion: true,
            ocurrioError: false
        }
    },
    methods: {
        usuarioTieneLaPaginaHabilitada: async function({ ruta }) {
            let habilitada = false;
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.VerificarSiTieneHabilitadaPagina;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDePagina: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: ruta })
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, TieneHabilitadaLaPagina } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    habilitada = TieneHabilitadaLaPagina
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return habilitada;
        },
         // SECCION PARA FUNCIONES
        iniciarProcesoCargaDeInformacion: async function() { 
            try {
                this.cargandoInformacion = true;
                const CARGO_CONTENIDOS_SIN_ERROR = await Promise.resolve(this.obtenerPaginaConSeccionesYContenidosBD());
                this.cargandoInformacion = !(CARGO_CONTENIDOS_SIN_ERROR);
                this.ocurrioError = this.cargandoInformacion;
                console.log('formatos::',this.secciones);
                $('html, body').animate({ scrollTop:0 }, 'slow');
            }
            catch(excepcion) {
                console.log(excepcion);
            }
        },
        obtenerPaginaConSeccionesYContenidosBD: async function() {
            let procesoSinError = false;
            console.log('route::',this.$route)
            try {
                const SERVIDOR = api.conexion;
                const METODO_API_OBTENER = api.SICPO.sistema.intranet.paginaintranet.ObtenerContenidosDeIntranetAdministracion;
                const SERVICIO_REST = SERVIDOR + METODO_API_OBTENER;
                let peticion = { 
                    RutaDeLaPaginaDeIntranet: this.obtenerPrefijoBaseDeLaRuta({ rutaDeLaPaginaDeIntranet: this.$route.fullPath }), 
                    PorAreaDeUsuario: true,
                    EsPrueba: false 
                };
                let peticionArchivos = false;
                let HEADER_PETICION = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, peticionArchivos,false);
                const RESPUESTA_PETICION = await axios.post(SERVICIO_REST, peticion, HEADER_PETICION);
                const DATOS_RESPUESTA = await RESPUESTA_PETICION.data;
                let { SiHayError, Error, PaginaDeIntranet } = DATOS_RESPUESTA;
                if (SiHayError) {
                    console.log(Error);
                } 
                else {
                    console.log('objPagina::',PaginaDeIntranet);
                    await Promise.resolve(this.convertirContenidosAObjetosDeFormatos({ pagina: PaginaDeIntranet }));
                    procesoSinError = true;
                }
            }
            catch(excepcion) {
                console.log(excepcion);
            }
            return procesoSinError;
        },
        obtenerPrefijoBaseDeLaRuta: function({ rutaDeLaPaginaDeIntranet }) { 
            let rutaBase = rutaDeLaPaginaDeIntranet;
            let elementosRuta = rutaDeLaPaginaDeIntranet.split('/');
            if(this.campoRequeridoEsValido(elementosRuta)) {
                // 1 parametros a eliminar para obtener la ruta base
                elementosRuta.pop();
                rutaBase = elementosRuta.join('/');
            }
            return rutaBase;
        },
        convertirContenidosAObjetosDeFormatos: async function({ pagina }) { 
            if(this.campoRequeridoEsValido(pagina)) {
                const { SeccionesDeIntranet } = pagina;
                if(this.campoRequeridoEsValido(SeccionesDeIntranet)) {
                    this.secciones = SeccionesDeIntranet.map(sBD => {
                        let seccionObj = {};
                        seccionObj.SeccionId = sBD.SeccionDeIntranetId;
                        seccionObj.Nombre = sBD.Nombre;
                        seccionObj.FormatoId = sBD.TipoFormato.TipoFormatoId;

                        if(this.campoRequeridoEsValido(sBD.SeccionesQueMePertenecen))
                            this.asignarEncabezadosDeArea({ secciones: sBD.SeccionesQueMePertenecen });
        
                        let contenidosDeSeccionObj = sBD.Contenidos.map((cBD) => {
                            let contenidoObj = this.TIPOS_CONVERSION_CONTENIDOS[sBD.TipoFormato.TipoFormatoId]({ contenido: cBD });
                            return contenidoObj;
                        });
                        seccionObj.Contenidos = contenidosDeSeccionObj;
                        return seccionObj;
                    });
                }
            }
        },
        asignarEncabezadosDeArea: function({ secciones }) { 
            const SECCION_TITULO_ID = 53;
            this.datosArea = {};
            secciones.forEach(s => {
                if(s.SeccionDeIntranetId == SECCION_TITULO_ID)
                    this.datosArea.titulo = (this.campoRequeridoEsValido(s.Contenidos)) ? s.Contenidos[0].TextoDelContenido : '';
            });
        },
        campoRequeridoEsValido: function(campo) { 
            let esValido = false
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = true;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = true;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = true;
                }
            }
            return esValido;
        }
    },
    async created() {
        //await Promise.resolve(this.iniciarProcesoCargaDeInformacion());
        // buscar en bd las secciones del area
        /* this.secciones = [
            { 
                SeccionId: 1,
                Nombre: 'Avisos',
                FormatoId: 32,
                Contenidos: [
                    { Titulo: 'Imagen 1', RutaDeAcceso: 'http://189.206.207.232:85/Files/SICPO/Pagina Oficial/19/31/2020/Noviembre/1550/Convocatoria CJE_ 05_2020.jpg', Descripcion: 'Descripcion imagen 1' },
                    { Titulo: 'Imagen 2', RutaDeAcceso: 'http://189.206.207.232:85/files/sicpo/Pagina Oficial/21/42/2020/Septiembre/741/fotonota10.jpeg', Descripcion: 'Descripcion imagen 2' },
                    { Titulo: 'Imagen 3', RutaDeAcceso: 'http://189.206.207.232:85/files/sicpo/Pagina Oficial/21/42/2020/Septiembre/741/fotonota10.jpeg', Descripcion: 'Descripcion imagen 3' }   
                ]
            },
        ]; */
    },
    async mounted() {
        await Promise.resolve(this.iniciarProcesoCargaDeInformacion());
    },
    watch: {
        '$store.state.Login_PermisosDelSistema': function() {
            console.log('permisos::',this.$store.state.Login_PermisosDelSistema);
        }
    }
}
</script>
<style scoped>
.espacio-entre-secciones {
    margin-top: 3vmin;
}

#contenedor-principal-clinicas {
    padding: 7vmin 16vmin 0vmin 16vmin;
}

#titulo-area h1 {
    font-size: 5vmin;
    font-weight: bold;
    color: #000000;
    margin-bottom: 0;
}

#titulo-area {
    margin-bottom: 3em;
}

#titulo-area h3 {
    font-size: 2.5vmin;
    color: #AF9C9C;
}

.hr-titulo {
    height:0.5em;
    width: 6em;
    border:none;
    background-color:#be9a5e;
}
</style>


// WEBPACK FOOTER //
// src/components/Intranet/Areas/Presidencia/CPresidencia.vue